import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { isDate } from 'lodash';

import { APP_DATE_FORMAT, APP_TIME_FORMAT, DEFAULT_TIMEZONE, MONTH } from '@/constants/date';

dayjs.extend(utc);
dayjs.extend(timezone);

export const isValidDate = (date: Date | null | undefined) =>
  date !== null && date !== undefined && isDate(new Date(date)) && date.toString() !== 'Invalid Date';

export const toDateFormat = (date: string | Date, format = APP_DATE_FORMAT) => {
  return dayjs(date).format(format);
};

export const toTimeFormat = (date: string | Date, format = APP_TIME_FORMAT) => {
  return dayjs(date).format(format);
};

export const getYearStartDate = (year: number) => {
  const startDate = dayjs().year(year).startOf('year').toDate();
  return toDateFormat(startDate.toDateString());
};

export const getYearEndDate = (year: number) => {
  const endDate = dayjs().year(year).endOf('year').toDate();
  return toDateFormat(endDate.toDateString());
};

export const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const getTimezoneOffset = () => {
  return dayjs().format('Z');
};

export const parseToDate = (date: string, timezone: string = DEFAULT_TIMEZONE) => {
  return dayjs(date).tz(timezone).toDate();
};

export const getYear = (date: Date) => {
  return dayjs(date).year();
};

export const getMonth = (date: Date) => {
  return MONTH[date.getMonth()];
};

export const getFormattedDateTimeWithOffset = (date: string | number) => {
  if (!isValidDate(new Date(date))) {
    return null;
  }

  const timezoneOffset = new Date().getTimezoneOffset() / -60;

  return {
    timezoneOffset: timezoneOffset >= 0 ? `+${timezoneOffset}` : `${timezoneOffset}`,
    date: toDateFormat(`${date}`),
    time: toTimeFormat(`${date}`, 'hh:mm:ss'),
    meridiem: dayjs(date).format('A'),
  };
};
